const UZBEK_SECTION_NAMES: Record<string, string> = {
  general: 'Umumiy',
  definition: 'Texnik ta’rif',
  technical_definition: 'Texnik ta’rif',
  structure: 'Paypoq tuzilishi',
  sock_structure: 'Paypoq tuzilishi',
  dimensions: 'O‘lchovlar',
  fixed_measurements: 'O‘lchovlar',
  measurements: 'O‘lchovlar',
  elements: 'Paypoq elementlari',
  sock_elements: 'Paypoq elementlari',
  materials: 'Xomashyolar',
  raw_materials: 'Xomashyolar',
  routes: 'Ishlab chiqarish yo‘nalishi',
  route: 'Ishlab chiqarish yo‘nalishi',
  production_route: 'Ishlab chiqarish yo‘nalishi',
  machines: 'Uskunalar',
  equipment: 'Uskunalar',
  quality: 'Sifat nazorati',
  qc: 'Sifat nazorati',
  qc_items: 'Sifat nazorati',
  quality_checks: 'Sifat nazorati',
  packaging: 'Qadoqlash',
  labels: 'Yorliqlar',
  threads: 'Iplar',
  yarns: 'Ip-kalavalar',
  costing: 'Tannarx',
  attachments: 'Ilovalar',
  revision: 'Tahrir',
  approvals: 'Tasdiqlovchi xodimlar',
  approval: 'Tasdiqlovchi xodimlar',
}

export function uzbekTechnicalPassportSectionName(section: string): string {
  const normalized = section.trim().toLocaleLowerCase().replace(/[\s-]+/g, '_')
  return UZBEK_SECTION_NAMES[normalized] ?? 'Noma’lum bo‘lim'
}

export function uzbekTechnicalPassportSectionNames(sections?: string[]): string[] {
  return (sections ?? []).map(uzbekTechnicalPassportSectionName)
}
